<!--Similar to BlogArticle, an EventArticle lists all event information in a concise
    format while allowing the user to add as much extra information and as many
    pictures as they like.
-->

<template>
  <div class="pad">
    <mdb-container class="mt-5" v-if="!loading">
      <mdb-row>
        <mdb-col md="12" class="mt-3">
          <mdb-card reverse>
            <mdb-view hover cascade>

              <!--Large banner image on top of article, resized in different rendition for mobile.
                  Banner contains title, author name, and date.                                    -->

              <img :src="`${banner_image}`" class="img-fluid d-none d-md-block"/>
              <img :src="`${banner_image_mobile}`" class="img-fluid d-md-none d-sm-block"/>
              <mdb-mask overlay="white-slight" class="waves-light" waves />
            </mdb-view>
            <mdb-card-body class="text-center" cascade>
              <h2 class="font-weight-bold">
                {{banner_title}}
              </h2>

            <!--If any date(s) given, show them-->

            <p v-if="page.start_date && page.end_date"><strong>Dates: </strong>{{toDateString(page.start_date)}} - {{toDateString(page.end_date)}}</p>
            <p v-else-if="page.start_date && !page.end_date"><strong>Date: </strong>{{toDateString(page.start_date)}}</p>
            
            <!--If any time(s) given, show them-->

            <p v-if="page.start_time && page.end_time"><strong>Times: </strong>{{toTimeString(page.start_time)}} - {{toTimeString(page.end_time)}}</p>   
            <p v-else-if="page.start_time && !page.end_time"><strong>Time: </strong>{{toTimeString(page.start_time)}}; this event has no specified end time.</p> 

            <!--If any venue is given, show it-->

            <p v-if="page.venue && page.venue_website"><strong>Location: </strong><a :href="page.venue_website" target="_blank">{{page.venue}}</a></p>
            <p v-else-if="page.venue"><strong>Location: </strong>{{page.venue}}</p>

            <!--If any additional information is given, show it-->

            <p v-if="page.additional_information"><i>{{page.additional_information}}</i></p>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <!--All other article content.-->

    <template v-for="block in content">
      <component :is="block.type" :block="block" :key="block.id"></component>
    </template>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbMask,
  mdbView
} from "mdbvue";
import axios from "axios";
import api from "@/api"
import title_and_text from "@/components/PlainComponents/title_and_text.vue";
import full_richtext from "@/components/PlainComponents/full_richtext.vue";
import multiple_image_carousel from "@/components/PlainComponents/multiple_image_carousel.vue";
import image_carousel from "@/components/PlainComponents/image_carousel.vue";
import quote_banner from "@/components/PlainComponents/quote_banner.vue";
import paragraph_and_image from "@/components/PlainComponents/paragraph_and_image.vue";
import call_to_action from "@/views/blog/components/call_to_action.vue";
import document_embed from "@/components/streamfields/document_embed.vue";
import shared from "@/shared";

export default {
  name: "EventPage",
  props: {
    slug: String
  },
  data() {
    return {
      page: String,
      banner_image: String,
      banner_image_mobile: String,
      banner_title: String,
      loading: true,
      content: Array
    };
  },
  mounted() {
    axios
      api.get("pages/" + this.slug)
      .then(response => {
        this.page = response.data;
        this.banner_image = this.page.banner_image_big.url;
        this.banner_image_mobile = this.page.banner_image_small.url;
        this.banner_title = this.page.title;
        this.content = this.page.body;
        shared.getDepartmentSkinFromPage(this.page);
      })
      .catch(e => {
        this.errors.push(e);
      })
      .finally(() => (this.loading = false));
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbMask,
    mdbView,
    title_and_text,
    full_richtext,
    multiple_image_carousel,
    image_carousel,
    quote_banner,
    paragraph_and_image,
    call_to_action,
    document_embed
  },
  methods: {
    toDateString: function(date) {
      var new_date = shared.getDate(date);
      return new_date.toLocaleDateString();
    },
    toTimeString: function(time) {
      return shared.TwelveHrTime(time);
    }
  }
};
</script>
